import {doGet} from './base/base_api_helper'

export function getModelPredictions(filter, auth){
  return doGet("general/vehicleModel", {
    _filter: filter
  }, auth)
}
